export default {
  props: {
    day: {
      type: Object,
      required: true,
    },

    list: {
      type: Function,
      required: true,
    },

    create: {
      type: Function,
      required: true,
    },

    edit: {
      type: Function,
      required: true,
    },
  },

  components: {
    VAppointmentCard: require('./../appointmentCard/appointmentCard.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/calendarDay/calendarDay.js